import React, { useEffect, useState, useRef, memo } from 'react';
import { StarIcon, ChevronLeftIcon, ChevronRightIcon, GiftIcon } from 'lucide-react';
export function Reviews() {
  // Bonus Carousel State
  const [currentBonusSlide, setCurrentBonusSlide] = useState(0);
  const [isBonusPaused, setIsBonusPaused] = useState(false);
  // Lifestyle Carousel State
  const [currentLifestyleSlide, setCurrentLifestyleSlide] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const bonusImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/5kLpWKCYRC5pzE7Ziozm6U/ptd.d_menus_festivos.png',
    alt: 'Menús Festivos Exprés de Navidad & Año Nuevo',
    value: '$27 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/c4DpvMeT2KB3ZFftiuZRYp/ptda.kit_antisobrantes.png',
    alt: 'Kit Anti-Sobrantes Navidad & Año Nuevo',
    value: '$19 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/dGVEhzmYDNbG5UXroHe5iw/portd.calculadora.png',
    alt: 'Calculadora de Fiesta Navideña',
    value: '$15 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/4DX33aZovz7HKPk7wyc1ui/portada_de_KIT.png',
    alt: 'Kit Imprimible & Editable de Menús',
    value: '$22 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/491VLAVVGxM8Xt439CkNvE/portada_principal.png',
    alt: 'Loncheras Que los Niños Devoran',
    value: '$25 USD'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/diBgsWNVKXeMATeqnyV5Ue/img_de_potrtda_de_7_dias_de_cenas_en_15_minutos.png',
    alt: '7 Días de Cenas en 15 Minutos',
    value: '$17 USD'
  }];
  const lifestyleImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/t9xGqmjHtNrQ4FzEHvzzbV/ChatGPT_Image_3_nov_2025,_10_26_32_p.m..png',
    alt: 'Mamá leyendo 50 Recetas en el auto'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/q6sVLS2CBzcXBH4h2v5kZS/modelo2.png',
    alt: 'Mujer profesional con tablet en la cocina'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/xACv3oifnfjjGxfryTRrHW/mujer_profesional_leyendo_50_recetas.png',
    alt: 'Profesional leyendo 50 Recetas'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/pG5e9BnYNTgkbxwqkhKy9h/madre_leyeno_50_recetas.png',
    alt: 'Madre e hija leyendo juntas'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/eaTdhDhoKB42AJJz5GPivQ/2portada_50_recetas.jpg',
    alt: 'Libro 50 Recetas de 15 Minutos'
  }];
  const reviews = [{
    initials: 'AM',
    date: '20/01/2025',
    name: 'Ana M.',
    location: 'Houston, TX (mamá y enfermera)',
    title: 'Ya no siento culpa',
    content: 'Entre el trabajo y la escuela de los niños, siempre terminaba pidiendo comida. Con este libro, en 15 minutos tengo cena casera y variada. Mis hijos se comen todo y yo ya no siento culpa. Lo mejor: ingredientes sencillos y pasos claros. Fue el empujón que necesitaba para organizarme.',
    rating: 5
  }, {
    initials: 'LR',
    date: '18/01/2025',
    name: 'Luis R.',
    location: 'Ciudad de México (papá soltero)',
    title: 'Me salvó entre semana',
    content: 'Me salvó entre semana. Los menús están pensados para la vida real: poco tiempo, mucho sabor. Armé una lista de 10 recetas favoritas y las repito. Gastamos menos en delivery y comemos mejor. Recomendado para papás con agenda apretada.',
    rating: 5
  }, {
    initials: 'VP',
    date: '16/01/2025',
    name: 'Valeria P.',
    location: 'Buenos Aires (maestra y mamá de 2)',
    title: 'Volví a disfrutar las noches',
    content: 'Volví a disfrutar las noches. Ya no improviso. Sigo la guía, cocino en 15 minutos y listo. Los molletes exprés y la pasta con maíz son éxito seguro. Además, los consejos de "preparaciones base" me ahorran tiempo toda la semana.',
    rating: 5
  }];
  // Auto-play logic for Bonus Carousel
  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (!isBonusPaused) {
      interval = setInterval(() => {
        setCurrentBonusSlide(prev => (prev + 1) % bonusImages.length);
      }, 4000);
    }
    return () => clearInterval(interval);
  }, [isBonusPaused, bonusImages.length]);
  const nextBonusSlide = () => {
    setCurrentBonusSlide(prev => (prev + 1) % bonusImages.length);
  };
  const prevBonusSlide = () => {
    setCurrentBonusSlide(prev => (prev - 1 + bonusImages.length) % bonusImages.length);
  };
  // Lifestyle Carousel Logic
  const nextLifestyleSlide = () => {
    setCurrentLifestyleSlide(prev => (prev + 1) % lifestyleImages.length);
  };
  const prevLifestyleSlide = () => {
    setCurrentLifestyleSlide(prev => (prev - 1 + lifestyleImages.length) % lifestyleImages.length);
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    setTouchStart(e.targetTouches[0].clientX);
  };
  const handleTouchMove = (e: React.TouchEvent) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 75) {
      nextLifestyleSlide();
    }
    if (touchStart - touchEnd < -75) {
      prevLifestyleSlide();
    }
  };
  return <section id="reviews" className="py-12 sm:py-16 md:py-20 bg-gradient-to-b from-white to-gray-50" data-id="element-621">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-622">
        {/* PREMIUM BONUS CAROUSEL - REDESIGNED */}
        <div className="mb-20 sm:mb-24" data-id="element-623">
          <div className="text-center mb-10" data-id="element-624">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-50 text-amber-700 text-xs font-bold tracking-widest uppercase mb-4 border border-amber-100 shadow-sm" data-id="element-625">
              <GiftIcon className="w-3.5 h-3.5" data-id="element-626" />
              <span data-id="element-627">Oferta Exclusiva</span>
            </div>
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 tracking-tight" data-id="element-628">
              6 Bonos de Regalo{' '}
              <span className="relative inline-block" data-id="element-629">
                <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-amber-500 to-orange-600" data-id="element-630">
                  Incluidos
                </span>
                <span className="absolute bottom-1 left-0 w-full h-3 bg-amber-100/50 -z-0 transform -rotate-1 rounded-full" data-id="element-631"></span>
              </span>
            </h2>
            <p className="text-gray-500 max-w-2xl mx-auto text-lg font-light" data-id="element-632">
              Complementos perfectos diseñados para maximizar tus resultados
              desde el primer día
            </p>
          </div>

          <div className="relative max-w-4xl mx-auto" onMouseEnter={() => setIsBonusPaused(true)} onMouseLeave={() => setIsBonusPaused(false)} data-id="element-633">
            {/* Elegant Background Glow */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-r from-amber-100/30 via-orange-50/30 to-amber-100/30 blur-3xl rounded-full -z-10" data-id="element-634"></div>

            {/* Compact Premium Carousel Container */}
            <div className="relative bg-white rounded-2xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.1)] border border-gray-100 overflow-hidden group hover:shadow-[0_25px_60px_-12px_rgba(245,158,11,0.15)] transition-all duration-500" data-id="element-635">
              {/* Main Display Area - More Compact Aspect Ratio */}
              <div className="aspect-[16/9] sm:aspect-[2.2/1] relative bg-gradient-to-br from-gray-50 via-white to-gray-50" data-id="element-636">
                {/* Slides Container */}
                <div className="absolute inset-0 flex transition-transform duration-700 cubic-bezier(0.4, 0, 0.2, 1) will-change-transform" style={{
                transform: `translateX(-${currentBonusSlide * 100}%)`
              }} data-id="element-637">
                  {bonusImages.map((image, index) => <div key={index} className="min-w-full h-full flex items-center justify-center p-6 sm:p-8" data-id="element-638">
                      <div className="relative w-full h-full flex items-center justify-center max-w-md mx-auto" data-id="element-639">
                        {/* Image Glow Effect */}
                        <div className="absolute inset-0 bg-gradient-to-tr from-amber-500/10 to-transparent blur-2xl rounded-full transform scale-75 opacity-0 group-hover:opacity-100 transition-opacity duration-700" data-id="element-640"></div>

                        {/* Product Image with Reflection */}
                        <div className="relative z-10 transform transition-transform duration-700 hover:scale-105" data-id="element-641">
                          <img src={image.src} alt={image.alt} className="relative max-h-[280px] sm:max-h-[320px] w-auto object-contain drop-shadow-2xl" data-id="element-642" />
                          {/* Reflection */}
                          <div className="absolute -bottom-4 left-0 right-0 h-12 bg-gradient-to-b from-white/20 to-transparent transform scale-y-[-0.3] opacity-30 blur-sm mask-image-gradient" data-id="element-643">
                            <img src={image.src} alt="" className="w-full h-full object-contain" aria-hidden="true" data-id="element-644" />
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>

                {/* Elegant Side Gradients */}
                <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white via-white/80 to-transparent pointer-events-none z-10" data-id="element-645"></div>
                <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white via-white/80 to-transparent pointer-events-none z-10" data-id="element-646"></div>

                {/* Minimalist Navigation Controls */}
                <button onClick={prevBonusSlide} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm border border-gray-100 shadow-lg flex items-center justify-center text-gray-600 hover:text-amber-600 hover:scale-110 transition-all duration-300 z-20 group/btn" aria-label="Anterior" data-id="element-647">
                  <ChevronLeftIcon className="w-5 h-5 group-hover/btn:-translate-x-0.5 transition-transform" data-id="element-648" />
                </button>

                <button onClick={nextBonusSlide} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/80 backdrop-blur-sm border border-gray-100 shadow-lg flex items-center justify-center text-gray-600 hover:text-amber-600 hover:scale-110 transition-all duration-300 z-20 group/btn" aria-label="Siguiente" data-id="element-649">
                  <ChevronRightIcon className="w-5 h-5 group-hover/btn:translate-x-0.5 transition-transform" data-id="element-650" />
                </button>
              </div>

              {/* Refined Bottom Bar */}
              <div className="bg-white border-t border-gray-50 px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-651">
                <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4" data-id="element-652">
                  <span className="text-sm font-medium text-gray-400 uppercase tracking-wider text-xs" data-id="element-653">
                    Bono {currentBonusSlide + 1} / {bonusImages.length}
                  </span>
                  <h3 className="text-base sm:text-lg font-bold text-gray-800 text-center sm:text-left line-clamp-1" data-id="element-654">
                    {bonusImages[currentBonusSlide].alt}
                  </h3>
                </div>

                {/* Modern Indicators */}
                <div className="flex items-center gap-2" data-id="element-655">
                  {bonusImages.map((_, index) => <button key={index} onClick={() => setCurrentBonusSlide(index)} className={`relative h-1.5 rounded-full transition-all duration-500 overflow-hidden ${currentBonusSlide === index ? 'w-12 bg-amber-500' : 'w-2 bg-gray-200 hover:bg-gray-300'}`} aria-label={`Ir a bono ${index + 1}`} data-id="element-656">
                      {currentBonusSlide === index && <div className="absolute inset-0 bg-white/30 animate-[shimmer_2s_infinite]" data-id="element-657"></div>}
                    </button>)}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* LIFESTYLE IMAGES SECTION (Original Logic Preserved) */}
        <div className="mb-16 sm:mb-20" data-id="element-658">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-10 text-gray-900" data-id="element-659">
            Familias Reales, Resultados Reales
          </h2>

          {/* Mobile Carousel */}
          <div className="md:hidden relative" data-id="element-660">
            <div className="relative overflow-hidden rounded-2xl shadow-xl bg-gray-100" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove} onTouchEnd={handleTouchEnd} data-id="element-661">
              <div className="flex transition-transform duration-500 ease-out" style={{
              transform: `translateX(-${currentLifestyleSlide * 100}%)`
            }} data-id="element-662">
                {lifestyleImages.map((image, index) => <div key={index} className="min-w-full flex items-center justify-center p-0" data-id="element-663"></div>)}
              </div>
            </div>

            <button onClick={prevLifestyleSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 text-gray-800 p-2 rounded-full shadow-lg hover:bg-white transition-all" aria-label="Anterior" data-id="element-664">
              <ChevronLeftIcon className="w-5 h-5" data-id="element-665" />
            </button>
            <button onClick={nextLifestyleSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 text-gray-800 p-2 rounded-full shadow-lg hover:bg-white transition-all" aria-label="Siguiente" data-id="element-666">
              <ChevronRightIcon className="w-5 h-5" data-id="element-667" />
            </button>

            <div className="flex justify-center gap-2 mt-4" data-id="element-668">
              {lifestyleImages.map((_, index) => <button key={index} onClick={() => setCurrentLifestyleSlide(index)} className={`h-1.5 rounded-full transition-all duration-300 ${currentLifestyleSlide === index ? 'bg-gray-800 w-6' : 'bg-gray-300 w-1.5'}`} data-id="element-669" />)}
            </div>
          </div>

          {/* Desktop Grid */}
          <div className="hidden md:grid md:grid-cols-12 gap-3 max-w-6xl mx-auto" data-id="element-670">
            {lifestyleImages.map((image, index) => <div key={index} className={`\n                  relative group overflow-hidden rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer\n                  ${index < 3 ? 'md:col-span-4 h-72' : 'md:col-span-6 h-80'}\n                `} data-id="element-671">
                {/* Image with slow zoom effect */}
                <img src={image.src} alt={image.alt} className="w-full h-full object-cover transform scale-100 group-hover:scale-110 transition-transform duration-1000 ease-out" data-id="element-672" />

                {/* Subtle initial overlay for premium feel */}
                <div className="absolute inset-0 bg-black/5 group-hover:bg-black/0 transition-colors duration-700" data-id="element-673" />

                {/* Hover Overlay Gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-674" />

                {/* Elegant Border */}
                <div className="absolute inset-0 border border-white/10 rounded-2xl pointer-events-none z-10" data-id="element-675" />

                {/* Content Reveal */}
                <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-500 z-20 opacity-0 group-hover:opacity-100" data-id="element-676">
                  <div className="flex items-center gap-3" data-id="element-677">
                    <div className="h-px w-8 bg-amber-400" data-id="element-678"></div>
                    <p className="text-white font-medium text-lg tracking-wide drop-shadow-md" data-id="element-679">
                      {image.alt}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* TESTIMONIALS SECTION */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-3" data-id="element-680">
          Lo Que Dicen las Familias
        </h2>
        <div className="text-center mb-8" data-id="element-681">
          <div className="text-2xl font-bold text-gray-900" data-id="element-682">4.9</div>
          <div className="text-sm text-gray-500" data-id="element-683">Basado en 2,847 Familias</div>
        </div>
        <div className="space-y-6" data-id="element-684">
          {reviews.map((review, index) => <div key={index} className="border border-amber-100 rounded-xl p-6 bg-white shadow-sm hover:shadow-md transition-shadow" data-id="element-685">
              <div className="flex flex-col items-center text-center md:flex-row md:items-start md:text-left gap-4" data-id="element-686">
                <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-600 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md flex-shrink-0" data-id="element-687">
                  {review.initials}
                </div>
                <div className="flex-1" data-id="element-688">
                  <div className="flex items-center justify-center md:justify-start gap-2 mb-2" data-id="element-689">
                    <div className="flex" data-id="element-690">
                      {[...Array(review.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-691" />)}
                    </div>
                    <span className="text-sm text-gray-400" data-id="element-692">{review.date}</span>
                  </div>
                  <div className="font-semibold text-gray-900 mb-1" data-id="element-693">
                    {review.name}
                  </div>
                  <div className="text-sm text-gray-500 mb-3" data-id="element-694">
                    {review.location}
                  </div>
                  <h3 className="font-bold mb-2 text-amber-600" data-id="element-695">
                    {review.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-696">
                    {review.content}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}